import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { ScheduleTime, TimeSelected } from '@mode/shared/schedules/contract';
import { hours } from './hour.constants';
import { minutes } from './minute.constants';
import { commonTimeZones, timeZones } from './time-zone.constants';

@Component({
  selector: 'mode-time-with-time-zone-selector',
  standalone: true,
  imports: [CommonModule, MatLegacySelectModule, MatDividerModule],
  templateUrl: './time-with-time-zone-selector.component.html',
  styleUrls: ['./time-with-time-zone-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeWithTimeZoneSelectorComponent implements OnChanges {
  @Input() schedule: ScheduleTime = {
    hour: 0,
    minute: 0,
    timeZone: 'UTC',
  };
  @Output() timeChanged = new EventEmitter<ScheduleTime>();

  public commonTimeZones = commonTimeZones;
  public timeZones = timeZones;
  public hours = hours;
  public minutes = minutes;

  public selectedHour: TimeSelected = { displayName: '', displayValue: '', value: 0 };
  public selectedMinute: TimeSelected = { displayName: '', displayValue: '', value: 0 };
  public selectedTimeZone = '';

  ngOnChanges(): void {
    this.selectedHour = <TimeSelected>this.hours.find((x) => x.value === this.schedule.hour);
    this.selectedMinute = <TimeSelected>this.minutes.find((x) => x.value === this.schedule.minute);
    this.selectedTimeZone = this.schedule?.timeZone;
  }

  public onTimeChanged() {
    this.timeChanged.emit({
      hour: this.selectedHour.value,
      minute: this.selectedMinute.value,
      timeZone: this.selectedTimeZone,
    });
  }
}
